import type { ChatSidebarMode } from '@/contexts/ChatSidebarContextDef';
import { ChatConversation } from '@/hooks/useChat';
import { cn } from '@/lib/utils';

import { ChatHeaderButtons } from './ChatHeaderButtons';
import { ConversationHistoryDropdown } from './ConversationHistoryDropdown';

interface ChatSidebarHeaderProps {
  conversations: ChatConversation[];
  currentConversationId: string | null;
  mode: ChatSidebarMode;
  showEmptyState: boolean;
  onNewConversation: () => void;
  onConversationSelect: (id: string) => void;
  onSwitchMode: () => void;
  onClose: () => void;
}

export const ChatSidebarHeader = (props: ChatSidebarHeaderProps) => (
  <div
    className={cn(
      'flex items-center gap-8 flex-shrink-0',
      props.mode === 'sidebar' ? 'p-6 pb-4' : 'p-4'
    )}
  >
    <div className="flex-1 min-w-0">
      <ConversationHistoryDropdown
        conversations={props.conversations}
        currentConversationId={props.currentConversationId}
        onConversationSelect={props.onConversationSelect}
      />
    </div>

    <ChatHeaderButtons
      mode={props.mode}
      showEmptyState={props.showEmptyState}
      onNewConversation={props.onNewConversation}
      onSwitchMode={props.onSwitchMode}
      onClose={props.onClose}
    />
  </div>
);
